import React from 'react'
import { Link } from 'react-router-dom'
import { ParallaxBanner, ParallaxBannerLayer } from 'react-scroll-parallax';

const AprilAtonementBanner = () => (
  <div style={{ backgroundColor: '#8498c1' }}>
    <div style={{ display: 'block', position: 'relative', width: '100vw', height: '140vw', overflow: 'hidden', backgroundImage: 'url("/assets/AA25_poster_5mmbleed.jpg")', backgroundSize: 'contain' }}>
      
    </div>

  </div>


)

export default AprilAtonementBanner
